import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { IconCircuitCapacitor, IconCircuitInductor, IconCircuitResistor } from "@tabler/icons-react";
import { observer } from "mobx-react-lite";
import * as React from "react";
import theme from "../../../../assets/theme";
import i18nStore from "../../../../i18n/store";


interface CustomRenderXRGBCellProps extends GridRenderCellParams<any, any> {
    realValue: number;
}
const CustomRenderXRGBCell = observer((params: CustomRenderXRGBCellProps) => {
    const translations = i18nStore.getTranslations;

    let val = params.realValue || params.value;
    if (isNaN(val)) {
        val = null;
    }
    return (
        <Tooltip title={params.value} placement="right">
            <Typography
                variant="inherit"
                component="span"
                color={ params.realValue === params.value ? "black" : "gray" }
                sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
            >
                {val > 0 && <Tooltip placement="top" title={translations._electricElements.inductor}><IconCircuitInductor color={theme.palette.grey.A400} /></Tooltip>}
                {val < 0 && <Tooltip placement="top" title={translations._electricElements.capacity}><IconCircuitCapacitor color={theme.palette.grey.A400} /></Tooltip>}
                {val == 0 && <Tooltip placement="top" title={translations._electricElements.resistor}><IconCircuitResistor color={theme.palette.grey.A400} /></Tooltip>}
                {val === null && ""}
                <Typography component="span">
                    {val !== null && val.toLocaleString('ru-RU')}
                </Typography>
            </Typography>
        </Tooltip>
    );
});


export default CustomRenderXRGBCell;
